import React from "react";

import { Action } from "./StudioControls";

// One primary action per screen state. Inline at the end of the section on wide
// windows; pinned to the bottom edge on narrow windows so it stays reachable.
// The hint sits under the button (inline) or above it (floating), never overlapping.
export const ActionBar = ({ action, isPending, secondary }) => {
  if (!action) return null;
  const button = (className, describedBy) => (
    <Action
      variant={action.destructive ? "destructive" : "primary"}
      className={className}
      disabled={action.disabled || isPending}
      aria-describedby={action.hint ? describedBy : undefined}
      onClick={action.onClick}
    >
      {isPending && action.pendingLabel ? action.pendingLabel : action.label}
    </Action>
  );
  return (
    <React.Fragment>
      <div className={`cs-action-inline ${secondary ? "has-secondary" : ""}`}>
        <div className="cs-action-inline__buttons">
          {secondary}
          {button("cs-action-inline__primary", "cs-action-hint")}
        </div>
        {action.hint && <p id="cs-action-hint" className="cs-action-hint">{action.hint}</p>}
      </div>
      <div className="cs-action-floating">
        <div className="cs-action-floating__inner">
          {action.hint && <p id="cs-action-hint-floating" className="cs-action-floating__hint">{action.hint}</p>}
          {button("cs-button--block", "cs-action-hint-floating")}
        </div>
      </div>
    </React.Fragment>
  );
};
